import React from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/default/button';
import ModalBody from '@atlaskit/modal-dialog/modal-body';
import Modal from '@atlaskit/modal-dialog/modal-dialog';
import ModalFooter from '@atlaskit/modal-dialog/modal-footer';
import ModalHeader from '@atlaskit/modal-dialog/modal-header';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';

import messages from './messages';

export interface FinishMigrationReviewModalProps {
	helpCenterName?: string;
	isOpen: boolean;
	isPending?: boolean;
	onCancel: () => void;
	onConfirm: () => void;
}

export const FinishMigrationReviewModal = ({
	helpCenterName,
	isOpen,
	isPending = false,
	onCancel,
	onConfirm,
}: FinishMigrationReviewModalProps): React.JSX.Element | null => {
	const { formatMessage } = useIntl();

	if (!isOpen) {
		return null;
	}

	return (
		<Modal onClose={onCancel}>
			<ModalHeader>
				<ModalTitle>{formatMessage(messages.title)}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				{formatMessage(helpCenterName ? messages.body : messages.bodyWithoutHelpCenterName, {
					helpCenterName,
				})}
				<VisuallyHidden>
					<span role="status">{isPending ? formatMessage(messages.saving) : ''}</span>
				</VisuallyHidden>
			</ModalBody>
			<ModalFooter>
				<Button appearance="subtle" onClick={onCancel}>
					{formatMessage(messages.cancel)}
				</Button>
				<Button
					appearance="warning"
					isDisabled={isPending}
					isLoading={isPending}
					onClick={onConfirm}
				>
					{formatMessage(messages.confirm)}
				</Button>
			</ModalFooter>
		</Modal>
	);
};
